import { CurrentUserInfoResponse, FrontEndSettingsResponse } from '@uptime-bff/api-contract';
import { TagTypes, uptimeApi } from 'core/api';

const usersApi = uptimeApi.injectEndpoints({
  endpoints: (build) => ({
    getCurrentUserInfo: build.query<CurrentUserInfoResponse, void>({
      query: (body) => ({
        url: 'users',
        method: 'GET',
        body,
      }),
    }),
    getFrontendSettings: build.query<FrontEndSettingsResponse, void>({
      query: () => ({
        url: 'users/settings',
        method: 'GET',
      }),
      providesTags: [TagTypes.FrontendSettings],
    }),
  }),
});

export const { useGetCurrentUserInfoQuery, useGetFrontendSettingsQuery } = usersApi;
